<template>
    <div class="one">
        <div>
            <img src="../../assets/channel1.png" alt="">
            <img src="../../assets/channel2.png" alt="">
            <img src="../../assets/channel3.png" alt="">
        </div>
        <p>线上消费场景无缝连接，通过佣金等级制度激励粉丝宣传推广，快速裂变全民卖货。</p>
    </div>
</template>
<script>
    export default {
        name: 'one'
    }
</script>
<style scoped>
    .one{
        position: relative;
        top: -480px;
        width: 658px;
        margin: 0 auto;
    }
    div{
        overflow: hidden;
    }
    div>img{
        float: left;
        margin: 0 10px;
        width: 30%;
    }
    p{
        font-size: 14px;
        color: #e5e5e5;
        text-align: center;
        padding-top: 20px;
        width: 690px;
    }

</style>



// WEBPACK FOOTER //
// src/components/indexr/one.vue